export default {
  en: {
    termsAndConditions: 'Terms & Conditions',
    editTermsAndConditions: 'Edit Terms & Conditions'
  },
  th: {
    termsAndConditions: 'ข้อตกลงและเงื่อนไข',
    editTermsAndConditions: 'แก้ไขข้อตกลงและเงื่อนไข'
  }
}
